import React, {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import FileSaver from "file-saver";
import LockScreenLoading from "../../../LockScreenLoading/LockScreenLoading";

// Material-UI Core
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TaskIcon from "@mui/icons-material/Task";
import EditIcon from "@material-ui/icons/Edit";
import PrintIcon from "@material-ui/icons/Print";
import FullScreenDialog from "../../../Dialog/FullScreenDialog";
import PilFileHistory from "./pilFileHistory";
import {generatePdf} from "../../../../dataSource/pil";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
// Custom Style
import {pilStyle} from "../../../../styles/jss/components/ProjectInformation/pilStyle";

const useStyles = makeStyles((theme) => pilStyle(theme));

const PilMaster = (props) => {
    const classes = useStyles();
    const store = require("store");
    const {editable, setEditable, htmlStr, pilDetails, setUpdateFlag, lock, lockRight} = props;
    const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [progressTitle, setProgressTitle] = useState("");
    const userModulesRedux = useSelector((state) => state.userModulesRedux);

    let title = editable ? "Project Information List(Edit)" : "Project Information List";
    let isPILEditable = userModulesRedux && userModulesRedux.find((obj) => obj.path === "/pil").rights.modifiable === true ? true : false;

    const printPDF = async () => {
        setLockScreenLoadingOpen(true);
        let signatureBOTTOM1 = `<div class="signature">
    <span style="width:65%"></span>
    <div style="width: 35%;">
        <p style="text-align: left;">Stage 1 Approved By</p>
        <p style="border-bottom: 1px solid black; width: 100%;height: 30px"></p>
    </div>
  </div>`;
        let signatureBOTTOM2 = pilDetails.uploadFiles.filter((obj) => obj.stage === "1").length > 0 ? `<div class="signature">
    <span style="width:65%"></span>
    <div style="width: 35%;">
        <p style="text-align: left;">Stage 2 Approved By</p>
        <p style="border-bottom: 1px solid black; width: 100%;height: 30px"></p>
    </div>
  </div>` : ``;
        let signatureStr = `<div style="display:none">%SIGNATURE%</div>`;
        let signature2Str = `<div style="display:none">%SIGNATURE2%</div>`;
        let dividerReplace = `<div class="STAGEDIVIDER" />`;
        let html = htmlStr
            .replace(signatureStr, signatureBOTTOM1)
            .replace(signature2Str, signatureBOTTOM2)
            .replace(dividerReplace, ``);

        const pdf = await generatePdf(html, store.get("site_code"));
        const fileExtension = ".pdf";
        FileSaver.saveAs(pdf, store.get("site_code") + fileExtension);
        setLockScreenLoadingOpen(false);
    };
    const dialogHandleClose = () => {
        setDialogOpen(false);
    };

    const setOpenHistoryDialog = () => {
        setDialogOpen(true);
    };
    return (<Fragment>
        <FullScreenDialog
            open={dialogOpen}
            dialogTitle={"Site Document History"}
            formContent={<PilFileHistory
                pilDetails={pilDetails}
                setUpdateFlag={setUpdateFlag}
                uploadable={isPILEditable}
                lock={!(lockRight || !lock)}
            />}
            button={[]}
            handleClose={dialogHandleClose}
        />
        <LockScreenLoading
            open={lockScreenLoadingOpen}
            circleSize={200}
            progressTitle={progressTitle}
        />
        <Box>
            <AppBar position="static" color="transparent">
                <Toolbar>
                    <Typography variant="h6" className={classes.appbarTest}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
        </Box>
        <div style={{marginBottom: "8px"}}>
            <div style={{float: "left"}}>
                <Grid container spacing={1}>
                    {!editable ? lock ? <IconButton>
                        <LockIcon color="info"></LockIcon>
                    </IconButton> : <IconButton>
                        <LockOpenIcon color="info"></LockOpenIcon>
                    </IconButton> : <></>}
                </Grid>
            </div>
            <div style={{float: "right"}}>
                <Grid container spacing={1}>
                    {(lockRight || !lock) && !editable && isPILEditable && (<><Tooltip title="Edit Project">
                        <IconButton
                            aria-label="edit"
                            onClick={() => {
                                setEditable(true);
                            }}
                        >
                            <EditIcon/>
                        </IconButton>
                    </Tooltip>
                    </>)}
                    {!editable && (<>
                        <Tooltip title="Upload Signed Site Document">
                            <IconButton aria-label="edit" onClick={setOpenHistoryDialog}>
                                <TaskIcon/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Print ">
                            <IconButton aria-label="print" onClick={printPDF}>
                                <PrintIcon/>
                            </IconButton>
                        </Tooltip>
                    </>)}
                </Grid>
            </div>
            <br/>
        </div>

    </Fragment>);
};

export default PilMaster;
